import React from 'react';
import { Company } from '../../../../../types/company';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { FeatureToggleItem, FeatureToggleTitle, FeatureToggleExplanation, FeatureToggleInformation } from '../common';

interface AlertFeatureTogglesViewProps {
  company: Company;
  update: (company: Company) => Promise<void>;
}

export default function AlertFeatureTogglesView({ company, update }: AlertFeatureTogglesViewProps) {
  const copy = new Company(company);
  const toggles = copy.settings.featureToggles.alerts;

  return (
    <FeatureToggleItem
      solo
      value={toggles.alerts}
      onChange={async value => await update(copy.withAlertsAlertFeatureToggle(value))}
    >
      <FeatureToggleTitle text={t(TranslationKey.alertAlertFeatureToggleTitle).singular.upper} />
      <FeatureToggleExplanation text={t(TranslationKey.alertAlertFeatureToggleExplanation).singular.upper} />
      <FeatureToggleInformation text={t(TranslationKey.alertAlertFeatureToggleInformation).singular.upper} />
    </FeatureToggleItem>
  );
}
